import { observable, makeObservable } from 'mobx'
import { DocumentTagDTO } from './dtos/document-tag'
import { DateZero, maybeParseDate } from 'utils/date-util'
import { Id } from 'types/definitions'
import { Model } from 'infra/model'
import once from 'lodash/once'

export default class DocumentTag extends Model<DocumentTagDTO, DocumentTag> {
  @observable id = Id.none
  @observable label = ''
  @observable color = ''
  @observable workspaceId = Id.none
  @observable dateCreated: Date = DateZero()
  @observable dateModified: Date = DateZero()

  constructor() {
    super()
    makeObservable(this)
  }

  static get none() {
    return lazyNone()
  }

  parse(json: Partial<DocumentTagDTO>): Partial<DocumentTag> {
    return {
      id: json.id,
      label: json.label,
      color: json.color,
      workspaceId: json.workspace_id,
      dateCreated: maybeParseDate(json.date_created),
      dateModified: maybeParseDate(json.date_modified),
    }
  }
}

const lazyNone = once(() =>
  new DocumentTag().set({
    label: 'Tag',
  }),
)
